/**
 * Builds a map of characteristic IDs to labels with fallback logic
 */
export const buildCharacteristicIdMap = (characteristicListing, recordCharacteristics) => {
  const map = {}

  // Add from record characteristics (fallback)
  if (Array.isArray(recordCharacteristics)) {
    for (const c of recordCharacteristics) {
      if (c?.id == null) continue
      const id = String(c.id)
      if (c.name) map[id] = c.name
    }
  }

  // Override with listing (priority)
  for (const c of characteristicListing) {
    if (c?.id == null) continue
    const id = String(c.id)
    map[id] = c.name || map[id] || `Characteristic ${c.id}`
  }

  return map
}

/**
 * Builds map from record characteristics
 */
export const buildRecordCharacteristicMap = (record) => {
  const map = {}
  if (Array.isArray(record?.characteristics)) {
    for (const c of record.characteristics) {
      if (c?.id == null) continue
      const id = String(c.id)
      if (c.name) map[id] = c.name
    }
  }
  return map
}
